import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { useIsMount, useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { ViewAllButton, ViewAllMiniButton } from '@yme/molecules/buttons';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { SectionWrapper } from '@yme/molecules/section-wrapper';
import { getCommonLabels, getRootLang, getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey, buildStateParam, getCardsColumnNumberForDesktop, getCardsColumnNumberForTablet, prepareDateRangeText, } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { UPCOMING_EVENTS_DATA_ID, UPCOMING_EVENTS_DESK_MAX_LINES, UPCOMING_EVENTS_MAX_CARD, UPCOMING_EVENTS_MOBILE_MAX_LINES, } from './constants';
import { calcMarginBottom, getLogoMaxHeight } from './helpers';
export function UpcomingEvents(props) {
    const { isRemoveBottomIndent, upcomingEvents, labels, eventsListingPagePath } = props;
    const { upcomingEvents_header_label: headerLabel } = labels;
    const isRightToLeft = useSelector(getRTL);
    const { common_readMore_link: readMoreLabel, common_viewAll_link: viewAllLabel } = useSelector(getCommonLabels);
    const lang = useSelector(getRootLang);
    const isMount = useIsMount();
    const { isMobileView, isInfiniteDesktopView, isTabletView } = useWindowSize();
    const FooterViewAllBtn = viewAllLabel && isMobileView && (React.createElement(ViewAllButton, { linkTo: eventsListingPagePath, isRightToLeft: isRightToLeft, viewAllLabel: viewAllLabel }));
    const HeaderViewAllBtn = viewAllLabel && !isMobileView && (React.createElement(FlexWrapper, { height: "100%", alignItems: "center" },
        React.createElement(ViewAllMiniButton, { linkTo: eventsListingPagePath, isRightToLeft: isRightToLeft, viewAllLabel: viewAllLabel })));
    const upcomingEventsCards = upcomingEvents.map((item, index) => {
        const { title, eventLogo, countryFlag, description, link, backgroundImage, dateFrom, dateTo, locationTitle, } = item;
        const caption = isMount
            ? ''
            : prepareDateRangeText({
                dateFrom,
                dateTo,
                lang,
                hasTime: false,
            });
        const eventCardsLength = upcomingEvents.length;
        const logoMaxHeight = getLogoMaxHeight({
            eventCardsLength,
            isInfiniteDesktopView,
            isTabletView,
        });
        const marginBottom = calcMarginBottom({
            length: eventCardsLength,
            isMobileView,
            isInfiniteDesktopView,
            isTabletView,
            index,
        });
        const cardProps = {
            title,
            description,
            image: backgroundImage,
            link,
            labelLink: readMoreLabel,
            caption,
            additionalCaption: locationTitle,
            eventLogo,
            flag: countryFlag,
            aspectRatio: AspectRatio.RectangleLevel3,
            marginBottom,
            logoMaxHeight,
            countLineVisible: isInfiniteDesktopView
                ? UPCOMING_EVENTS_DESK_MAX_LINES
                : UPCOMING_EVENTS_MOBILE_MAX_LINES,
        };
        if (!upcomingEvents) {
            return null;
        }
        return (React.createElement(Col, { key: buildKey(buildStateParam()), lg: getCardsColumnNumberForDesktop(eventCardsLength, UPCOMING_EVENTS_MAX_CARD), md: getCardsColumnNumberForTablet(eventCardsLength) },
            React.createElement(CardForEvents, { cardProps: cardProps, isRightToLeft: isRightToLeft })));
    });
    if (props?.upcomingEvents?.length === 0) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(SectionWrapper, { headerLeftSide: headerLabel, isRightToLeft: isRightToLeft, isVerticalIndentDefault: false, isExpanded: false, headerRightSide: HeaderViewAllBtn, bottomSection: FooterViewAllBtn, desktopRatio: {
                leftSide: 9,
                rightSide: 3,
            } },
            React.createElement(Container, { dataTestId: UPCOMING_EVENTS_DATA_ID, isRightToLeft: isRightToLeft },
                React.createElement(Row, null, upcomingEventsCards)))));
}
UpcomingEvents.displayName = 'UpcomingEvents_AEMComponent';
